import React from "react";
import { Mail, Phone } from "lucide-react";

const HEADSHOT =
  "https://customer-assets.emergentagent.com/job_87b778f0-2c90-438f-b95e-468b4d830fb8/artifacts/piy3626c_TEAM%20PHOTOS%2009-08-17%20007.jpg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative border-b border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-20 md:pb-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-end">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <p
            className="reveal font-mono text-xs uppercase tracking-[0.3em] text-[var(--accent-primary)] mb-6"
            data-testid="hero-overline"
          >
            // Founder · Creative Director · Cinematographer
          </p>

          <h1
            className="reveal font-display font-black uppercase leading-[0.85] tracking-[-0.04em] text-[clamp(3rem,9vw,8.5rem)]"
            style={{ animationDelay: "0.05s" }}
            data-testid="hero-name"
          >
            Alex
            <br />
            <span className="text-white/80">Moore</span>
            <span className="text-[var(--accent-primary)]">.</span>
          </h1>

          <p
            className="reveal mt-8 max-w-xl text-white/70 text-base md:text-lg leading-relaxed font-body"
            style={{ animationDelay: "0.15s" }}
            data-testid="hero-summary"
          >
            Founder of{" "}
            <a
              href="https://www.weddingvideo.co.uk/"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-link-wve"
              className="text-white link-underline hover:text-[var(--accent-primary)] transition-colors"
            >
              Wedding Video Essex
            </a>
            ,{" "}
            <a
              href="https://www.wvestudios.co.uk/"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-link-studios"
              className="text-white link-underline hover:text-[var(--accent-primary)] transition-colors"
            >
              WVE Studios
            </a>{" "}
            and the{" "}
            <a
              href="https://www.wvegroup.co.uk/"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-link-group"
              className="text-white link-underline hover:text-[var(--accent-primary)] transition-colors"
            >
              WVE Group
            </a>
            . A decade of wedding cinema, live event production and broadcast
            grade media. 900+ weddings captured, seven industry awards, twenty
            six recommended venues.
          </p>

          <div
            className="reveal mt-10 flex flex-wrap items-center gap-3"
            style={{ animationDelay: "0.25s" }}
          >
            <a
              data-testid="hero-email-button"
              href="mailto:alex@weddingvideo.co.uk"
              className="btn-yellow inline-flex items-center gap-2 px-6 py-4 font-mono text-[11px] uppercase tracking-[0.25em] font-bold"
            >
              <Mail className="w-4 h-4" />
              alex@weddingvideo.co.uk
            </a>
            <a
              data-testid="hero-phone-button"
              href="tel:+447513011412"
              className="btn-outline inline-flex items-center gap-2 px-6 py-4 font-mono text-[11px] uppercase tracking-[0.25em] font-bold"
            >
              <Phone className="w-4 h-4" />
              07513 011412
            </a>
          </div>

          <div
            className="reveal mt-10 flex flex-wrap items-center gap-6 font-mono text-[11px] uppercase tracking-[0.25em] text-white/50"
            style={{ animationDelay: "0.35s" }}
          >
            <a
              href="https://www.wvegroup.co.uk"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-website"
              className="link-underline hover:text-white"
            >
              wvegroup.co.uk ↗
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2 relative">
          <div className="relative">
            <span className="absolute -top-2 -left-2 w-4 h-4 border-t border-l border-[var(--accent-primary)]" />
            <span className="absolute -top-2 -right-2 w-4 h-4 border-t border-r border-[var(--accent-primary)]" />
            <span className="absolute -bottom-2 -left-2 w-4 h-4 border-b border-l border-[var(--accent-primary)]" />
            <span className="absolute -bottom-2 -right-2 w-4 h-4 border-b border-r border-[var(--accent-primary)]" />

            <div className="overflow-hidden border border-white/15 bg-[#121212]">
              <img
                data-testid="hero-portrait"
                src={HEADSHOT}
                alt="Alex Moore, Founder and Creative Director of Wedding Video Essex"
                className="w-full h-auto block grayscale-[10%] contrast-105"
                width="2048"
                height="2048"
                fetchpriority="high"
                decoding="async"
                loading="eager"
              />
            </div>

            <div className="mt-3 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
              <span>FILE · ALEXMOORE_HEADSHOT.JPG</span>
              <span>ISO 400 · F/4 · 1/200</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
